import React from "react"
import PropTypes from "prop-types"
import { VACATION_STATES } from "../../../consts/modules/vacations.consts"
import VacationStatusChip from "../../../components/molecules/VacationStatusChip.molecule"
import { Ripple } from "primereact/ripple"
import {
  getVacationRangeLabel,
  getVacationState,
  getVacationTooltip,
  isForeignSchema,
  vacationEventHasNotification,
} from "../../../utils/vacation.utils"
import { Skeleton } from "../../../components/atoms/misc/Skeleton.atom"
import VacationDayTypesBreakdown from "./VacationDayTypesBreakdown.molecule"

const VacationPendingRequestCard = ({
  onClick = () => {},
  onContextMenu = null,
  vacationRequest = {},
  teamMember = {},
  mode = "admin",
  loading = false,
  ...props
}) => {
  const vacationState = getVacationState(vacationRequest, {
    showBlocked: vacationRequest.active === 0,
    showPendingChange: !!vacationRequest.changeRequest,
    showCanceled: !!vacationRequest.cancelRequest
  })
  
  if (loading) {
    return <VacationPendingRequestCardSkeleton />
  }
  return (
    <div
  className={`request-card p-ripple ${vacationState === VACATION_STATES.BLOCKED ? "p-disabled" : ""}`}
  onClick={(e) => {
    if (vacationState !== VACATION_STATES.BLOCKED) {
      onClick(vacationRequest)
    }
  }}
  onContextMenu={(e) => {
    if (onContextMenu) {
      e.preventDefault()
      onContextMenu(e, vacationRequest)
    }
  }}
>
  <div className="flex justify-content-between">
    <div className="flex flex-column gap-2" style={{ minWidth: "120px" }}>
      <div className="flex gap-1 align-items-center">
        <i className="pi pi-calendar"></i>
        <span>
          {getVacationRangeLabel(
            vacationRequest?.numberOfVacationDays,
            vacationRequest?.startDate,
            vacationRequest?.endDate
          )}
        </span>
      </div>

      {!isForeignSchema(teamMember.idHolidaySchema) && (
        <div className="flex gap-1 align-items-center" style={{ alignSelf: 'flex-start' }}>
          <VacationDayTypesBreakdown vacationRequest={vacationRequest} />
        </div>
      )}
    </div>

    <div className="flex flex-column justify-content-center align-items-start" style={{ minWidth: "120px" }}>
      <VacationStatusChip
        status={vacationState}
        variant="long"
        tooltipContent={{
          title: getVacationTooltip(vacationRequest),
          position: "left",
        }}
        notification={false}
        showTooltip={false}
        pendingDayPlusPay={!!(vacationRequest.numberOfPlusDays > 0 && !vacationRequest.plusDaysPayedOff)}
        shortLabel
      />
    </div>
  </div>
  <Ripple />
</div>
  )
}

export default VacationPendingRequestCard

VacationPendingRequestCard.propTypes = {
  onClick: PropTypes.func,
  vacationRequest: PropTypes.shape({
    numberOfVacationDays: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    numberOfBucketDays: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    numberOfPlusDays: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    numberOfAdditionalDays: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    changeRequest: PropTypes.bool,
    plusDaysPayedOff: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    vacationsHaveBeenCounted: PropTypes.number,
  }),
  teamMember: PropTypes.shape({
    fullName: PropTypes.string,
    idHolidaySchema: PropTypes.number,
  }),
  props: PropTypes.object,
  mode: PropTypes.string,
}

export const VacationPendingRequestCardSkeleton = () => {
  return (
    <div className={`request-card p-ripple skeleton`}>
      <div
        className="flex justify-content-between align-items-center"
        style={{ height: "20px" }}
      >
        <div className="flex gap-1">
          <i className="pi pi-user"></i>
          <Skeleton />
        </div>
        <Skeleton height={"20px"} />
      </div>
      <div className="flex gap-1">
        <i className="pi pi-calendar"></i>
        <Skeleton height={"20px"} />
      </div>
      <Skeleton height={"21px"} />
    </div>
  )
}
